<template>
  <el-dialog class="tag-display-dialog" :visible.sync="isShowPopup" :show-close="false" width="900px" :close-on-click-modal="false" >
    <div slot="title" class="popup-header">
      <span class="popup-title">{{ $t("title.tag.priority.title") }}</span>
      <div class="title-btn">
        <sp-smart-button v-show="this.$checkAuth('010310')" class="cancel-btn" @click="handleClose">{{$t("button.common.cancel")}}</sp-smart-button>
        <narrow-down v-show="this.$checkAuth('010310')" class="create-btn m-left-2" @click="create">{{$t("button.common.data.create")}}</narrow-down>
      </div>
    </div>
    <el-form class="tag-display-form" label-position="left" :model="tagPriorityForm">
      <el-form-item
        class="m-bottom-2"
        :label="$t('label.tag.priority.tagDisplay1')"
      >
        <el-select
          v-model="tagPriorityForm.tagGroup01.tagGroupId"
          class="tag-select m-right-5"
          :placeholder="$t('label.tag.priority.placeholder')"
          @change="tagGroup01Change">
          <el-option
            v-for="index in meetingTagGroupList"
            :label=index.meetingTagGroupName
            :value=index.meetingTagGroupId
            :key=index.meetingTagGroupId>
          </el-option>
        </el-select>
        <el-radio v-model="tagPriorityForm.tagGroup01.reserveTopDisplayStatus" label="01">{{ $t('label.tag.priority.normalDisplay') }}</el-radio>
        <el-radio v-model="tagPriorityForm.tagGroup01.reserveTopDisplayStatus" label="02">{{ $t('label.tag.priority.imageDisplay') }}</el-radio>
      </el-form-item>
      <el-form-item
        class="margin-bottom-4"
        :label="$t('label.tag.priority.tagDisplay2')"
      >
        <el-select
          v-model="tagPriorityForm.tagGroup02.tagGroupId"
          class="tag-select m-right-5"
          :placeholder="$t('label.tag.priority.placeholder')"
          @change="tagGroup02Change">
          <el-option
            v-for="index in meetingTagGroupList"
            :label=index.meetingTagGroupName
            :value=index.meetingTagGroupId
            :key=index.meetingTagGroupId>
          </el-option>
        </el-select>
        <el-radio v-model="tagPriorityForm.tagGroup02.reserveTopDisplayStatus" label="01">{{ $t('label.tag.priority.normalDisplay') }}</el-radio>
        <el-radio v-model="tagPriorityForm.tagGroup02.reserveTopDisplayStatus" label="02">{{ $t('label.tag.priority.imageDisplay') }}</el-radio>
      </el-form-item>

      <hr class="tag-hr m-bottom-2" />

      <el-form-item
        class="m-bottom-2"
        :label="$t('label.tag.priority.homeDisplay')"
      >
        <el-select
          v-model="tagPriorityForm.homeDisplay"
          class="tag-select"
          :placeholder="$t('label.tag.priority.placeholder')">
          <el-option
            v-for="index in homeTagGroupList"
            :label=index.meetingTagGroupName
            :value=index.meetingTagGroupId
            :key=index.meetingTagGroupId>
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>

    <loading-dialog :dialogVisible="showLoading" />
  </el-dialog>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import statusErrorCodeMsg from "@/utils/status-error-msg";
import errorCodeMsg from "@/utils/error-code-msg";
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import SystemManageApi from "@/api/SystemManageApi";

export default {
  name: "TagPriorityPopup",
  components: {SpSmartButton, narrowDown, LoadingDialog},
  props: {
    isShowPopup: {
      type: Boolean,
      default: false
    },
    buildingId: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      showLoading: false,
      tagPriorityForm: {
        homeDisplay: '',
        tagGroup01: {
          tagGroupId: '',
          reserveTopDisplayStatus: '01'
        },
        tagGroup02: {
          tagGroupId: '',
          reserveTopDisplayStatus: '01'
        },
      },
      meetingTagGroupList: [],
      homeTagGroupList: [],
    }
  },
  methods: {
    loadTagInfo () {
      this.showLoading = true;
      this.meetingTagGroupList = [];
      SystemManageApi.OutlookBuildMeetingTagGet(this.buildingId)
        .catch((error) => {
          errorCodeMsg(error, this);
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return
          }
          if (data.body !== undefined && data.body !== null && data.body.length > 0) {
            this.meetingTagGroupList.push({
              meetingTagGroupId: '',
              meetingTagGroupName: '',
            })
            data.body.forEach((info) => {
              if (info.meetingTagGroupId !== null && info.meetingTagGroupId !== '') {
                this.meetingTagGroupList.push({
                  buildingId: info.buildingId,
                  meetingTagGroupId: info.meetingTagGroupId,
                  meetingTagGroupName: info.meetingTagGroupName,
                  homeDisplayFlag: info.homeDisplayFlag,
                  reserveTopDisplayStatus: info.reserveTopDisplayStatus,
                  reserveTopDisplayOrder: info.reserveTopDisplayOrder,
                  displayOrder: info.displayOrder,
                  meetingTagList: info.meetingTagList,
                })
              }
            })
            this.init()
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },

    init () {
      this.homeTagGroupList = [{
        meetingTagGroupId: "",
        meetingTagGroupName: ""
      }]

      this.meetingTagGroupList.sort((a, b) => {return a.displayOrder - b.displayOrder})
      this.meetingTagGroupList.forEach((tagGroup) => {

        if (tagGroup.reserveTopDisplayStatus !== '' && tagGroup.reserveTopDisplayStatus !== null) {
          if (tagGroup.reserveTopDisplayStatus == '01' || tagGroup.reserveTopDisplayStatus == '02') {
            if ((this.tagPriorityForm.tagGroup01.tagGroupId == '' || this.tagPriorityForm.tagGroup01.tagGroupId == null) && tagGroup.reserveTopDisplayOrder == '01') {
              this.tagPriorityForm.tagGroup01.tagGroupId = tagGroup.meetingTagGroupId
              this.tagPriorityForm.tagGroup01.reserveTopDisplayStatus = tagGroup.reserveTopDisplayStatus
            } else {
              this.tagPriorityForm.tagGroup02.tagGroupId = tagGroup.meetingTagGroupId
              this.tagPriorityForm.tagGroup02.reserveTopDisplayStatus = tagGroup.reserveTopDisplayStatus
            }

            if (tagGroup.reserveTopDisplayOrder != undefined && tagGroup.reserveTopDisplayOrder != null && tagGroup.reserveTopDisplayOrder != '') {
              if (tagGroup.reserveTopDisplayOrder == '01') {
                this.homeTagGroupList.push({
                  meetingTagGroupId: tagGroup.meetingTagGroupId,
                  meetingTagGroupName: "タググループ1"
                })
              } else if (tagGroup.reserveTopDisplayOrder == '02') {
                this.homeTagGroupList.push({
                  meetingTagGroupId: tagGroup.meetingTagGroupId,
                  meetingTagGroupName: "タググループ2"
                })
              }
            }
          }
        }

        if (tagGroup.homeDisplayFlag) {
          this.tagPriorityForm.homeDisplay = tagGroup.meetingTagGroupId
        }

        this.homeTagGroupList.sort(function(a, b){
          return a.meetingTagGroupName.localeCompare(b.meetingTagGroupName)
        })

      })
    },

    create () {
      if (
        !this.$IsNullOrEmpty(this.tagPriorityForm.tagGroup01.tagGroupId) ||
        !this.$IsNullOrEmpty(this.tagPriorityForm.tagGroup02.tagGroupId)
      ) {
        if (this.tagPriorityForm.tagGroup01.tagGroupId == this.tagPriorityForm.tagGroup02.tagGroupId) {
          this.$messageIotError(this.$t('message.common.error.ERR_TAG_GROUP_PRIORITY_DISPLAY_MSG'));
          return;
        }
      }


      var homeDisplayFlag = false

      let meetingTagGroupList = []
      if (!this.$IsNullOrEmpty(this.tagPriorityForm.tagGroup01.tagGroupId)) {

        if (!this.$IsNullOrEmpty(this.tagPriorityForm.homeDisplay)) {
          if (this.tagPriorityForm.homeDisplay ==  this.tagPriorityForm.tagGroup01.tagGroupId) {
            homeDisplayFlag = true
          }
        }
        meetingTagGroupList.push({
          meetingTagGroupId: this.tagPriorityForm.tagGroup01.tagGroupId,
          homeDisplayFlag: homeDisplayFlag,
          reserveTopDisplayStatus: this.tagPriorityForm.tagGroup01.reserveTopDisplayStatus,
          reserveTopDisplayOrder: '01'
        })
      }

      homeDisplayFlag = false
      if (!this.$IsNullOrEmpty(this.tagPriorityForm.tagGroup02.tagGroupId)) {

        if (!this.$IsNullOrEmpty(this.tagPriorityForm.homeDisplay)) {
          if (this.tagPriorityForm.homeDisplay ==  this.tagPriorityForm.tagGroup02.tagGroupId) {
            homeDisplayFlag = true
          }
        }

        meetingTagGroupList.push({
          meetingTagGroupId: this.tagPriorityForm.tagGroup02.tagGroupId,
          homeDisplayFlag: homeDisplayFlag,
          reserveTopDisplayStatus: this.tagPriorityForm.tagGroup02.reserveTopDisplayStatus,
          reserveTopDisplayOrder: '02'
        })
      }

      this.showLoading = true;
      SystemManageApi.OutlookBuildMeetingTagGroupPriorityUpdate(this.buildingId, meetingTagGroupList)
        .catch((error) => {
          errorCodeMsg(error, this);
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          if(data.statusCode == 'Success'){
            this.$messageIotSuccess(this.$t("message.common.saveSuccess", {
              field: this.$t("button.tag.tagGroupEdit.tagGroupPrioritySettings"),
            }));
            this.handleClose();
          }

        })
        .finally(() => {
          this.showLoading = false;
        })
    },

    clearForm () {
      this.tagPriorityForm.homeDisplay = ''
      this.tagPriorityForm.tagGroup01.tagGroupId = ''
      this.tagPriorityForm.tagGroup01.reserveTopDisplayStatus = '01'
      this.tagPriorityForm.tagGroup02.tagGroupId = ''
      this.tagPriorityForm.tagGroup02.reserveTopDisplayStatus = '01'
      this.meetingTagGroupList = []
    },

    handleClose () {
      this.clearForm()
      this.$emit("update:isShowPopup", false)
      this.$emit("close")
    },

    tagGroup01Change(newVal){
      if (this.homeTagGroupList.length > 1) {
        this.homeTagGroupList.sort(function(a, b){
          return a.meetingTagGroupName.localeCompare(b.meetingTagGroupName)
        })
        if (this.homeTagGroupList[1].meetingTagGroupName == 'タググループ1') {
          this.homeTagGroupList.splice(1, 1);
        }
      }
      if (newVal != undefined && newVal != null && newVal != '') {
        this.homeTagGroupList.splice(1, 0, {meetingTagGroupId: newVal, meetingTagGroupName: "タググループ1"})
        var homeDisplayTagGroup = this.homeTagGroupList.filter(tagGroup => tagGroup.meetingTagGroupId == this.tagPriorityForm.homeDisplay)
        if (homeDisplayTagGroup == undefined || homeDisplayTagGroup == null || homeDisplayTagGroup.length == 0) {
          this.tagPriorityForm.homeDisplay = newVal
        }
      } else {
        if (this.homeTagGroupList.length == 1) {
          this.tagPriorityForm.homeDisplay = ''
        } else if (this.homeTagGroupList.length == 2) {
          if (this.tagPriorityForm.homeDisplay != this.homeTagGroupList[1].meetingTagGroupId) {
            this.tagPriorityForm.homeDisplay = newVal
          }
        }
      }
    },
    tagGroup02Change(newVal){
      if (this.homeTagGroupList.length > 1) {
        this.homeTagGroupList.sort(function(a, b){
          return a.meetingTagGroupName.localeCompare(b.meetingTagGroupName)
        })
        if (this.homeTagGroupList[1].meetingTagGroupName == 'タググループ2') {
          this.homeTagGroupList.splice(1, 1);
        } else {
          this.homeTagGroupList.splice(2, 1);
        }
      }

      if (newVal != undefined && newVal != null && newVal != '') {
        if (this.homeTagGroupList.length > 1) {
          this.homeTagGroupList.splice(2, 0, {meetingTagGroupId: newVal, meetingTagGroupName: "タググループ2"})
          let homeDisplayTagGroup = this.homeTagGroupList.filter(tagGroup => tagGroup.meetingTagGroupId == this.tagPriorityForm.homeDisplay)
          if (homeDisplayTagGroup == undefined || homeDisplayTagGroup == null || homeDisplayTagGroup.length == 0) {
            this.tagPriorityForm.homeDisplay = newVal
          }

        } else {
          this.homeTagGroupList.splice(1, 0, {meetingTagGroupId: newVal, meetingTagGroupName: "タググループ2"})
          let homeDisplayTagGroup = this.homeTagGroupList.filter(tagGroup => tagGroup.meetingTagGroupId == this.tagPriorityForm.homeDisplay)
          if (homeDisplayTagGroup == undefined || homeDisplayTagGroup == null || homeDisplayTagGroup.length == 0) {
            this.tagPriorityForm.homeDisplay = newVal
          }
        }
      } else {
        if (this.homeTagGroupList.length == 1) {
          this.tagPriorityForm.homeDisplay = ''
        } else if (this.homeTagGroupList.length == 2) {
          if (this.tagPriorityForm.homeDisplay != this.homeTagGroupList[1].meetingTagGroupId) {
            // this.tagPriorityForm.homeDisplay = this.homeTagGroupList[1].meetingTagGroupId
            this.tagPriorityForm.homeDisplay = newVal
          }
        }
      }
    }
  },
  watch: {
    isShowPopup (value) {
      if (value) {
        this.$authCheck('010310')
        this.loadTagInfo()
      }
    }
  },
}
</script>

<style scoped>
.popup-header {
  display: flex;
  align-items: center;
}

.popup-title {
  font-family: "Hiragino Kaku Gothic Pro";
  font-size: 24px;
  font-weight: 300;
  line-height: 36px;
  color: #525250;
}

.title-btn {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.create-btn {
  display: flex;
}

.cancel-btn,
.create-btn::v-deep .el-button {
  width: 152px;
  height: 32px;
}

.tag-select {
  width: 322px;
}

.tag-hr {
  height: 1px;
  border: none;
  background-color: #B8B8B4;
}

.tag-display-dialog .el-radio {
  margin-right: 40px;
}

.tag-display-dialog::v-deep .el-dialog {
  padding: 40px !important;
}

.tag-display-dialog::v-deep .el-form-item__label {
  width: 135px;
  padding: 0px 8px 0px 0px;
  font-family: "Hiragino Kaku Gothic Pro";
  font-size: 12px;
  font-weight: 600;
  color: #525250;
}

.tag-display-dialog::v-deep .el-dialog .el-dialog__header {
  margin-bottom: 40px;
}
</style>
